import './not-found.scss';

function NotFound() {
  return (
    <main className="main not-found__main">
      <h1 className="not-found__title">404</h1>
      <p className="not-found__text">Страница не найдена</p>
    </main>
  );
}

export default NotFound;
